import { type Theme, useMediaQuery } from '@mui/material';

/** True below the `md` breakpoint, where the terminal switches to its mobile layout. */
export function useIsMobile() {
  return useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
}
